import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment, TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN, PHONE_NUMBER_REGEX } from "../../environments/environment"
import { ApiService } from "./api.service";
import Swal from 'sweetalert2';
import { SMSModel } from "../models/sms.model";

@Injectable({
    providedIn: "root"
})
export class SMSService {

    private baseUrl: string = 'managerial';

    accountSid = TWILIO_ACCOUNT_SID;
    authToken = TWILIO_AUTH_TOKEN;
    sms: SMSModel = new SMSModel(0, '', '', 0, 'TDM', '', []);
    editNumber = false;

    constructor(
        private api: ApiService
    ) {
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }
    
    get clinicData(): any {
        return (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.userData.clinic_no);
    }


    sendSMS() {
        let promesa = new Promise(async (resolve, reject) => {
            let body = new FormData();
            body.append('From', this.clinicData.web_phone); 
            body.append('Body', `Patient ${this.sms.pet_no} -- ${this.sms.doctor} -- ${this.sms.message}`);
            body.append('To', this.sms.to);
            if (this.sms.media_url !== '') {
                body.append('MediaUrl', this.sms.media_url);
            }

            let headers = new HttpHeaders({
                'Authorization': "Basic " + btoa(`${TWILIO_ACCOUNT_SID}:${TWILIO_AUTH_TOKEN}`),
                // 'Content-Type': 'application/x-www-form-urlencoded'
            });
            // headers.set('Content-Type', 'application/json');
            // headers.set("Authorization", "Basic " + btoa(`${this.accountSid}:${this.authToken}`));

            this.api.posth(`https://api.twilio.com/2010-04-01/Accounts/${TWILIO_ACCOUNT_SID}/Messages.json`, body, headers)
                .subscribe(() => {
                    resolve(1);
                }, (error) => {
                    reject(error);
                });
        });
        return promesa;
    }

    setupDocuments(files: SMSModel) {
        let promise = new Promise((resolve, reject) => {
            // console.log(JSON.stringify(files));

            this.api.post(`${this.baseUrl}/setupDocuments`, files)
                .subscribe((res: any) => {
                    if (res && res.media_url) {
                        resolve(res.media_url);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

}

/*
size images, number of pictures, and cost
check multiple users

*/